import { post } from '@/services/Axios';
import qs from 'qs';
import errorHandler from '@/mixins/errorHandler';

export default {
  mixins: [errorHandler],
  data() {
    return {
      loadingStartMeeting: false
    };
  },
  methods: {
    async startMeeting(uid) {
      this.loadingStartMeeting = true;
      const requestBody = { account_id: uid };
      const payload = qs.stringify(requestBody);
      try {
        const { data } = await post('/get-token-call', { data: payload });
        return data;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadingStartMeeting = false;
      }
    }
  }
};
